import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation, Link } from 'react-router-dom';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import { formatDate, formatDateTime } from '../Utils/GlobalUtils';

import HeadlinePanel from '../Components/HeadlinePanel';

import LoadingLines from '../Components/LoadingLines';
import WarningPanel from '../Components/WarningPanel';
import ExampleTable from './ExampleTable';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as CopyIcon } from '../icons/copy.svg';

export default function ViewFeedback() {
    const { openTimeModal } = useTimeModal();
    const navigate = useNavigate();
    const location = useLocation();

    const [feedbacks, setFeedbacks] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    React.useEffect(() => {
      setLoading(true);

      axios.get(`/api/get-all-feedbacks`)
      .then(response => {
          setWarning('');
          setFeedbacks(response.data);
      })
      .catch(error => {
        console.error(error);
        setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
      })
      .finally(() => {
        setReload(false);
        setLoading(false);
      });
    }, [reload]);

    const changeStatusFeedback = (feedbackIdForChangeStatus, status='В работе') => {
      axios.put('/api/change-feedback-status', {
            id: feedbackIdForChangeStatus,
            status: status
      }, {})
      .then(() => {
        openTimeModal('Статус обращения изменён', 'success');
        setReload(true);
      })
      .catch((error) => {
        openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
      });
    };
    
    const deleteFeedback = (feedbackIdForDelete) => {
      const token = localStorage.getItem("token");

      axios.delete('/api/delete-feedback', {
      data: { 
        id:feedbackIdForDelete 
      },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(() => {
        openTimeModal('Обращение удалено', 'success');
        setReload(true);
      }
      )
      .catch((error) => {
        openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
      });
    };
  
  

    return (
        <div className='mainContainer'>
          <HeadlinePanel label='Просмотр обращений в поддержку' type='На главную' />
          <div className='containerInner'>
            {/* <ExampleTable />   */}
            <div className='tableContainer'>
              <div className='tableHeaderWrapper'>
                <div className='tableHeader' style={{ gridTemplateColumns: '18fr 10fr 43fr 10fr 20fr' }}>
                  <div>Email</div>
                  <div>Тип вопроса</div>
                  <div>Текст обращения</div>
                  <div>Статус</div>
                  <div></div>
                </div>
              </div>
              {(!feedbacks && loading) ? <LoadingLines />
              : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить таблицу' buttonAction={() => setReload(true)} />
              : feedbacks.map((feedback) => (
                  <div 
                    className='tableRow nonActive' 
                    style={{ gridTemplateColumns: '18fr 10fr 43fr 10fr 20fr' }} 
                    key={feedback.id}
                  >
                    <div>
                      <span style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
                          <a
                            className='aWithLink'
                            href={`mailto:${feedback.user_email}`}
                          >
                            {feedback.user_email}
                          </a>
                          <IconContainer 
                              Icon={CopyIcon} 
                              label={'Скопировать'} 
                              onClick={() => {
                                  navigator.clipboard.writeText(feedback.user_email);
                                  openTimeModal('Email скопирован', 'success');
                              }} 
                              size = '15' 
                              color = 'black' 
                              className = '' 
                          />
                      </span>
                      {feedback.user_id && 
                      <>
                        <span className='horizontalLine'></span>
                        <Link
                            className='aWithLink'
                            to={`/account/${feedback.user_id}`}
                        >
                            ({feedback.lastname} {feedback.firstname} {feedback.surname})
                        </Link>
                      </>}
                      <span className='description'>{formatDateTime(feedback.created_at)}</span>
                    </div>
                    <div>
                      {feedback.type}
                    </div>
                    <div>
                      {feedback.message}
                    </div>
                    <div>
                      {feedback.status==='Открыто' ? <p className='textPill green'>Открыто</p> : ''}
                      {feedback.status==='В работе' ? <p className='textPill blue'>В работе</p> : ''}
                      {feedback.status==='Закрыто' ? <p className='textPill red'>Закрыто</p> : ''}
                    </div>
                    <div>
                      {feedback.status == 'Открыто' ? 
                      <>
                        <button type='button' className='tableButton' style={{width: '100%'}} onClick={() => changeStatusFeedback(feedback.id, 'В работе')}>В работе</button>
                        <button type='button' className='tableButton' style={{width: '100%'}} onClick={() => changeStatusFeedback(feedback.id, 'Закрыто')}>Закрыть</button>
                      </>
                      : <></>}
                      {feedback.status == 'В работе' ? 
                      <>
                        <button type='button' className='tableButton' style={{width: '100%'}} onClick={() => changeStatusFeedback(feedback.id, 'Открыто')}>Вернуть в открытые</button>
                        <button type='button' className='tableButton' style={{width: '100%'}} onClick={() => changeStatusFeedback(feedback.id, 'Закрыто')}>Закрыть</button>
                      </>
                      : <></>}
                      {feedback.status == 'Закрыто' ? 
                      <>
                        <button type='button' className='tableButton' style={{width: '100%'}} onClick={() => changeStatusFeedback(feedback.id, 'Открыто')}>Открыть</button>
                        <button type='button' className='tableButton red' style={{width: '100%'}} onClick={() => deleteFeedback(feedback.id)}>Удалить</button>
                      </>
                      : <></>}
                    </div>
                  </div>
              ))}
              </div>
          </div>
        </div>
    )
}
